import React, { useEffect, useState } from 'react'
import './profile.scss'
import { useLocation } from "react-router-dom";
import { update } from 'lodash';



const Newsletter = ({ newsletter, orgNo, setUpdatedNewsgroup }) => {

    const [updatedNewsletter, setUpdatedNewsletter] = useState()
    const [isChecked, setIsChecked] = useState(newsletter.Active === 1 || updatedNewsletter?.Active === 1 ? true : false)
    const [checked_arr, setChecked_arr] = useState([])
    const [triggerEffect, setTriggerEffect] = useState(false)
    let key = sessionStorage.getItem('key')
    let email = sessionStorage.getItem('email')
    const baseUrl = window.location.href.indexOf('localhost') != -1 ? 'https://localhost:44390/' : window.location.protocol + '//' + window.location.host + '/api/';

   // console.log(newsletter, 'newsletter')

    function newsletterChanged(e) {
       // console.log(e)
        const id = e.target.id;
        const checked = e.target.checked;
        setIsChecked(checked)
        let sign_on = checked === true ? 1 : 0
        let obj = {
            id: id,
            customerEmail: email,
            isSubscribed:checked
        }
     //   console.log(obj, 'obj')
             postNewsletter(obj)
            .then((res) => console.log(res))
            //.then(result => console.log(result))
            fetch(`http://dev.ebillet.dk/systemnative/customer.asmx/UpdateNewsgroup?Key=${key}&OrgNo=${orgNo}&NewsgroupNo=${newsletter.No}&SignOn=${sign_on}`, {
                method: "GET",
        
                    })
             .then((res) => res.json())
                .then(result => {
                   // console.log(result, 'result from update')
                    setUpdatedNewsletter(result)
                    setUpdatedNewsgroup(result)
                })
    }
  //  console.log(updatedNewsletter, 'updated newsletter')
    function postNewsletter(body) {
        return fetch(`${baseUrl}newsletters`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(body)
        });
    }


   
    return (
        <label key={newsletter.No} onClick={() => setTriggerEffect(true)} onAnimationEnd={() => setTriggerEffect(false)}>
          
            <input style={{ width: '20px', height: '20px', marginRight: '10px',borderRadius:'3px' }} type="checkbox" id={newsletter.No} checked={isChecked}
                onChange={newsletterChanged} />
          
                        {newsletter.Name}
                         {isChecked ? <span className={triggerEffect ? 'subscribed fade-in-out' : 'subscribed'}> Tilmeldt</span> :
                                   <span className={triggerEffect ? 'unsubscribed fade-in-out' : 'unsubscribed'}> Frameldt</span>}
          </label>
                                   
      
    )
}

export default Newsletter